import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-986d574a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-info" }
const _hoisted_2 = { class: "info-container" }
const _hoisted_3 = { class: "tab-list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_8 = { class: "contact-container" }
const _hoisted_9 = { class: "contact-item" }
const _hoisted_10 = { class: "contact-item" }
const _hoisted_11 = { class: "address" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code-container" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage('/product', '产品中心'))),
          class: "tab-item"
        }, " 产品中心 "),
        _hoisted_4,
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage('/news', '行业动态'))),
          class: "tab-item"
        }, " 行业动态 "),
        _hoisted_5,
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToPage('/detail?id=38', '项目案例'))),
          class: "tab-item"
        }, " 项目案例 "),
        _hoisted_6,
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage('/scheme', '产品方案'))),
          class: "tab-item"
        }, " 产品方案 "),
        _hoisted_7,
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage('/about', '关于我们'))),
          class: "tab-item"
        }, " 关于我们 ")
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, "Tel：" + _toDisplayString(_ctx.state.companyInfo.mobile), 1),
        _createElementVNode("div", _hoisted_10, "E-mail：" + _toDisplayString(_ctx.state.companyInfo.email), 1)
      ]),
      _createElementVNode("div", _hoisted_11, " 地址：" + _toDisplayString(_ctx.state.companyInfo.address), 1)
    ]),
    _hoisted_12
  ]))
}